<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="recipesSelected"
    chips
    multiple
    clearable
    deletable-chips
    small-chips
    :items="recipesItems"
    :loading="recipesLoading"
    :search-input.sync="recipesSearch"
    item-text="Description"
    item-value="id"
    :label="$t('Recipes.ObjectName')"
    return-object
  ></v-autocomplete>
  <!-- menu-props="closeOnContentClick" -->
</template>

<script>
import Recipes from "@/api/recipes";

export default {
  name: "SearcherRecipes",

  props: ["value"],

  computed: {
    recipesItems() {
      return this.recipes.map((recipe) => {
        const Description = recipe.formula_code + " / " + recipe.formula_name;
        return Object.assign({}, recipe, { Description });
      });
    },
  },

  data: () => ({
    recipes: [],
    recipesLoading: false,
    recipesSearch: "",
    recipesSelected: [],
  }),

  mounted() {
    this.getRecipesFromAPI();
  },

  methods: {
    getRecipesFromAPI() {
      this.recipesLoading = true;
      Recipes.fetchAllForSelect()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.recipes = response.data.food_formula;
              if (this.$route.query.formula_id) {
              let res = this.recipes.filter((v) => {
                return v.id == this.$route.query.formula_id;
              });
              this.recipesSelected = res;
            }
            }
            this.recipesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.recipesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.recipesSelected = this.value;
      },
    },
    recipesSelected: {
      handler() {
        this.$emit("input", this.recipesSelected);
      },
    },
  },
};
</script>
